module.exports = __webpack_public_path__ + "static/media/gutgereift_landing2-min.2aafa387.jpg";